import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { RepresentativeService } from 'src/app/Service/Representative/Representative.service';

@Component({
  selector: 'app-RepresentativeAdd',
  templateUrl: './RepresentativeAdd.component.html',
  styleUrls: ['./RepresentativeAdd.component.scss']
})
export class RepresentativeAddComponent implements OnInit {


  Token:String=""
  PreUserName:string=''
  InProccessing:boolean=false

  constructor(
    private Nav_Service:NavService,
    private Representative_Service:RepresentativeService,
    private Alertify_Service:AlertifyService,
  ) { }

  ngOnInit() {

    this.Token=localStorage.getItem('Daro_User_Token');

    this.FormAddRepresentative=new FormGroup({
      id :new FormControl(),
      Username:new FormControl(null,Validators.required),
      Password:new FormControl('',[
                                      Validators.required,
                                      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
                                    ]),
      FName:new FormControl(null,Validators.required),
      LName:new FormControl(null,Validators.required),

    })

    this.Nav_Service.CheckValidPage(this.Token,1101).subscribe(
      data=>{
        this.Representative_Service.GetSubusername(this.Token).subscribe(
          data=>{
            this.PreUserName=data['user']
            this.Read_Data_Menu()
          }
        ),error=>{
          localStorage.clear()
          location.reload();

        }
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Data_List_Menu:Array<Nav_Interface>=[]
  Read_Data_Menu(){
    this.Nav_Service.GetUser(this.Token,0,true).subscribe(
      data=>{
        this.Data_List_Menu=data
        this.Data_List_Menu=this.FilterNav(0)
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  FilterNav(id:Number):Array<Nav_Interface>{
    var tempList:Array<Nav_Interface>=[]
    for(let item of this.Data_List_Menu)
    {
      if(item.parent==id)
      {
          var temp:Nav_Interface=Empty_Nav_Interface()
          temp.id=item.id
          temp.icon=item.icon
          temp.link=item.link
          temp.parent=item.parent
          temp.title=item.title
          temp.child=this.FilterNav(item.id)

          tempList.push(temp)
      }

    }
    return tempList


  }

  Data_List_Menu_Change(id:Nav_Interface)
  {
    id.selected=!id.selected
  }

    //#region  Form Add

    FormAddRepresentative:FormGroup;

    get_Form_Username(){
      return this.FormAddRepresentative.get('Username') as FormControl;
    }

    get_Form_Password(){
      return this.FormAddRepresentative.get('Password') as FormControl;
    }

    get_Form_FName(){
      return this.FormAddRepresentative.get('FName') as FormControl;
    }

    get_Form_LName(){
      return this.FormAddRepresentative.get('LName') as FormControl;
    }

    //#endregion


    SubmitRepresentative(){

      var SelectedMenu:Array<number>=[]
      for(let lvl1 of this.Data_List_Menu)
      {
        for(let item of lvl1.child)
        {
          if(item.selected)
          {
            SelectedMenu.push(item.id)
          }
        }
      }


      var Record:User_Interface=Empty_User_Interface()
      Record.id=0
      Record.username=this.PreUserName + this.get_Form_Username().value
      Record.password = this.get_Form_Password().value
      Record.fname = this.get_Form_FName().value
      Record.lname = this.get_Form_LName().value
      Record.type=4
      this.Representative_Service.AddUser(Record,this.Token,SelectedMenu).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered username already exists in the list.")
          }
          else if(data.id==-1){
            this.Alertify_Service.ErrorMessage("No more than three active representatives can be registered.")
          }
          else{
            this.FormAddRepresentative.reset()
            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )

    }

}
